export default __webpack_public_path__ + "static/media/juice.8e0094ab.svg";